export const MM_PRACTICE_GET = 'MM_PRACTICE_GET'
